@if (open) {
<div class="perfil-enviar-modal" role="dialog" aria-modal="true" aria-labelledby="perfil-enviar-title"
  (click)="onBackdrop($event)">
  <div class="perfil-enviar-modal__panel" (click)="$event.stopPropagation()">
    <header class="perfil-enviar-modal__header">
      <span class="perfil-enviar-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="perfil-enviar-modal__title" id="perfil-enviar-title">
        {{ copy.titulo }}
      </h2>
      <button type="button" class="perfil-enviar-modal__close" aria-label="Cerrar" [disabled]="enviando"
        (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="perfil-enviar-modal__body">
      <ul class="perfil-enviar-modal__list">
        @for (paso of copy.pasos; track $index) {
        <li class="perfil-enviar-modal__item">
          <span class="material-icons perfil-enviar-modal__check" aria-hidden="true">check</span>
          <p class="perfil-enviar-modal__text">
            @if (paso.enlace) {
            <span>{{ paso.antes }}</span>
            <span class="perfil-enviar-modal__link">{{ paso.enlace }}</span>
            <span>{{ paso.despues }}</span>
            } @else {
            {{ paso.texto }}
            }
          </p>
        </li>
        }
      </ul>

      <div class="perfil-enviar-modal__actions">
        <button type="button" class="perfil-enviar-modal__btn perfil-enviar-modal__btn--secondary"
          id="btn-perfil-enviar-revisar" [disabled]="enviando" (click)="onRevisar()">
          {{ copy.ctaRevisar }}
        </button>
        <button type="button" class="perfil-enviar-modal__btn perfil-enviar-modal__btn--primary"
          id="btn-perfil-enviar-solicitud" [disabled]="enviando" (click)="onEnviar()">
          {{ enviando ? copy.ctaEnviando : copy.ctaEnviar }}
        </button>
      </div>
    </div>
  </div>
</div>
}
